import { fromJS } from 'immutable';

import _ from 'lodash';

import { getTenant, setTenant } from '../utils/authenticated';
import {
  loginRoutine,
  fetchUserRoutine,
  fetchTenantsRoutine,
  upgradeTenantRoutine,
  getTaskCountRoutine,
  getPaymentSourceRoutine,
  updatePaymentSourceRoutine,
  selectTenantRoutine,
  fetchInvoicesRoutine, addTenantRoutine,
} from '../routines';

const initialState = fromJS({
  tenants: [],
  loading: true,
  tenant: getTenant(),
  taskCount: -1,
  paymentSource: null,

  loadingInvoices: true,
  invoices: [],
});

export default function (state = initialState, action) {
  switch (action.type) {
    case addTenantRoutine.SUCCESS:
      console.log('action', );
      return state.updateIn(['tenants'], (tenants) => tenants.push(fromJS(_.assign({ permissions: ['Administrator'] }, action.payload))));
    case fetchTenantsRoutine.TRIGGER:
      return state.set('loading', true);
    case fetchTenantsRoutine.SUCCESS:
      return state.set('loading', false).set('tenants', fromJS(action.payload));
    case fetchTenantsRoutine.FAILURE:
      return state.set('loading', false);
    case upgradeTenantRoutine.SUCCESS:
      const resp = action.payload;
      if (resp.data.settings) {
        const settings = resp.data.settings;
        const tenant = _.assign(getTenant(), { settings: _.assign(getTenant().settings, settings) });

        setTenant(tenant);
        return state.set('tenant', fromJS(tenant));
      }

      return state;
    case loginRoutine.SUCCESS:
    case fetchUserRoutine.SUCCESS:
      return state.set('tenant', fromJS(getTenant()));
    case selectTenantRoutine.SUCCESS:
      localStorage.setItem('tenant', JSON.stringify(action.payload));
      return state.set('tenant', fromJS(action.payload));

    case getTaskCountRoutine.SUCCESS:
      return state.set('taskCount', action.payload.count);

    case getPaymentSourceRoutine.SUCCESS:
      return state.set('paymentSource', fromJS(action.payload));
    case updatePaymentSourceRoutine.SUCCESS:
      return state.set('paymentSource', fromJS(action.payload.data));

    case fetchInvoicesRoutine.TRIGGER:
      return state.set('loadingInvoices', true);
    case fetchInvoicesRoutine.SUCCESS:
      return state.set('loadingInvoices', false).set('invoices', fromJS(action.payload));
    case fetchInvoicesRoutine.FAILURE:
      console.log('FULFILL');
      return state.set('loadingInvoices', false);
    default :
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/tenants.js